import {
    initSnowplowTracker,
    triggerSnowplowPageViewEvent,
} from '@themuse/snowplow-js-client';
import React from 'react';

import useUser from '../../useUser';

export enum PAGE_VIEW_SECTIONS {
    ARTICLES = 'articles',
    ADVICE = 'advice',
    OTHER = 'other',
}

export enum PAGE_VIEW_TYPES {
    SINGLE_CONTENT = 'single_content',
    COLLECTION = 'collection',
    CONTENT = 'content',
    ENTITY = 'entity',
    FEED = 'feed',
    LANDING_PAGE = 'landing_page',
    MESSAGING = 'messaging',
    USER_INPUT = 'user_input',
    OTHER = 'other',
}

export const SnowplowPageViewTracker = (props: {
    pageCompanyId?: number | null;
    pageEntityId?: string | null;
    pageSection?: string | null;
    pageTab?: number | null;
    pageType?: string;
}) => {
    const { user, userLoading } = useUser();
    const {
        pageCompanyId = null,
        pageEntityId = null,
        pageSection = PAGE_VIEW_SECTIONS.OTHER,
        pageTab = null,
        pageType = PAGE_VIEW_TYPES.OTHER,
    } = props;
    React.useEffect(() => {
        const snowplowCollector = process.env.NEXT_PUBLIC_SNOWPLOW_COLLECTOR_ENDPOINT;
        const snowplowAppId = process.env.NEXT_PUBLIC_SNOWPLOW_APP_ID;

        if (!snowplowCollector || !snowplowAppId) {
            console.warn(
                'Snow plow Collector or Id not set up',
                snowplowCollector,
                snowplowAppId
            );
            return;
        }

        window.dataLayer = window.dataLayer || [];

        const index = window.dataLayer.findIndex(
            (obj) => 'sp_page_section' in obj
        );

        const pageData = {
            sp_page_sponsor_id: pageCompanyId ? String(pageCompanyId) : null,
            sp_page_company_id: pageCompanyId ? String(pageCompanyId) : null,
            sp_page_entity_id: pageEntityId ? String(pageEntityId) : null,
            sp_page_is_external: false,
            sp_page_section: pageSection,
            sp_page_tab: pageTab,
            sp_page_type: pageType,
            sp_user_id: user.id,
            sp_user_logged_in: !!user.id,
        };

        if (index >= 0) {
            window.dataLayer[index] = pageData;
        } else {
            window.dataLayer.push(pageData);
        }

        if (!userLoading) {
            initSnowplowTracker(snowplowCollector, snowplowAppId, true);
            triggerSnowplowPageViewEvent();
        }
    }, [user, userLoading]);

    return null;
};
